import { GetBatchReports, GetBatchReportsVariables } from "_graphql/queries/__generated__/GetBatchReports";

import { getBatchReports } from "_graphql/visal/queries/reports";
import { useQuery } from "@apollo/client";

export const useBatchReports = (variables: GetBatchReportsVariables) => {
  const { data, ...rest } = useQuery<GetBatchReports, GetBatchReportsVariables>(
    getBatchReports,
    {
      variables: variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const batchReports = data?.data || [];

  return { batchReports, count: data?.count || 0, ...rest };
};

